/**
 * 接口域名的管理
 */
import service from "../request/http";
// const baseUrl = 'https://wuji.oa.com/api/object';
const baseUrl = 'https://wujicdn.wetvinfo.com/cache/wuji/object';
export const GetOfferList = (params) => {
  params.appid = 'WeTV_Web';
  params.schemaid = 'hr_recruiting';
  params.schemakey = 'd48edf108458474b87d648e2d2b27ddf';
  return service.get(baseUrl, { params });
}
